import { FlatTreeControl } from '@angular/cdk/tree';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { RootStoreState } from '@app/root-store';
import { environment } from '@env/environment';
import { select, Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { SharedConfirmationDialogComponent } from '../component/shared-confirmation-dialog/shared-confirmation-dialog.component';
import { DragDropService } from './drag-drop/drag-drop.service';
import { FileDataObjectTransferService } from './file-data-object-transfer/file-data-object-transfer.service';
import { fetchAuthSession, fetchUserAttributes } from '@aws-amplify/auth';
interface DIRECTORY {
  name: string;
  data: any;
  children?: DIRECTORY[];
}

let TREE_DATA: DIRECTORY[] = [];

interface DirectoryFlatNode {
  expandable: boolean;
  name: string;
  level: number;
  data: any;
  completed: boolean;
}
export enum VaultUserFormOrigin {
  workspace = 'workspace',
  vault = 'vault',
}
export enum fileStatus {
  success = 'success',
  fail = 'fail',
  running = 'running',
}
@Injectable({
  providedIn: 'root',
})
export class TreeStructureService {
  FiletListDataList;

  // Worker reference for proper cleanup
  private createGroupWorker: Worker | undefined;

  private transformer = (node: any, level: number) => {
    let data = node.data;
    data.originalFile = node.originalFile;
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      level: level,
      data: data,
    };
  };
  data;
  hasFile = false;
  subscription = new Subscription();
  treeControl = new FlatTreeControl<DirectoryFlatNode>(
    (node) => node.level,
    (node) => node.expandable
  );

  treeFlattener = new MatTreeFlattener(
    this.transformer,
    (node) => node.level,
    (node) => node.expandable,
    (node) => node.children
  );
  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
  constructor(
    private store: Store,
    private dragDropService: DragDropService,
    private store$: Store<RootStoreState.State>,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private fileDataObjectTransferService: FileDataObjectTransferService
  ) {}
  async createTreeStructure(data) {
    this.data = data;
    await this.StartUploading(
      data,
      data['workspaceId'],
      data['folderId'],
      data['url'],
      data['isUploadDedByFolder'],
      data['workSpaceFodlerName'],
      data['vault_folder_id'],
      data['userId'],
      data['isFile']
    );
  }
  async StartUploading(data, workspaceId, folderId, url, isUploadDedByFolder, workSpaceFodlerName, vault_folder_id, userId, isFile) {
    this.fileDataObjectTransferService.sendMessage('true');
    let currentWorkSpaceId = workspaceId;
    let currentWorkspaceOwner;

    let alreadSendData = [];
    let origin = 'workspace';
    let isOficeWorkSpace = true;
    // const workspace_selector = this.store$.pipe(select(workspace_selectors.getWorkspace(currentWorkSpaceId)));
    // this.subscription.add(
    //   workspace_selector.subscribe((res) => {
    //     currentWorkspaceOwner = res.workspaceOwner;
    //   })
    // );
    if (data.fromDrag) {
      await this.getDraggedItem(data, workspaceId, folderId, url, workSpaceFodlerName, vault_folder_id, userId, isFile);
    } else {
      this.getUploadedItem(folderId, workspaceId, url, isUploadDedByFolder, workSpaceFodlerName, vault_folder_id, userId, isFile);
    }
  }
  async getUploadedItem(folderId, workspaceId, url, isUploadDedByFolder, workSpaceFodlerName, vault_folder_id, userId, is_file) {
    let items = [];

    for (let i = 0; i < this.data.items.length; i++) {
      try {
        let item = this.data.items[i];
        item.uniquesKey = this.data.uniquesKey;
        item.completed = false;
        item.isFile = true;
        item.workSpaceFodlerName = workSpaceFodlerName;
        item.originalFile = this.data.items[i];
        item.isDirectory = false;
        items.push(item);
      } catch (error) {}
    }
    const files = items;
    this.data.folderList = [...files];
    const tree = this.dragDropService.parsePathArray(this.data.folderList);
    TREE_DATA = [...tree];
    this.dataSource.data = [...TREE_DATA];
    this.fileDataObjectTransferService.sendMessage('false');

    let result;
    if (is_file) {
      result = await this.createGroupData(folderId, userId);
    }

    this.dataSource.data.forEach((element, index) => {
      this.fileDataObjectTransferService.updateApprovalMessage({
        data: this.dataSource.data[index],
        folderId,
        workspaceId,
        url,
        isUploadDedByFolder: isUploadDedByFolder,
        vault_folder_id,
        userId,
        is_file,
        groupId: result?.data?.id,
      });
    });
  }
  async createGroupData(parentFolderData, userId) {
    return await new Promise(async (resolve) => {
      if (typeof Worker !== 'undefined') {
        // Terminate previous worker if exists
        if (this.createGroupWorker) {
          this.createGroupWorker.terminate();
        }

        this.createGroupWorker = new Worker(new URL('./../component/common-upload-dialog/bulk-file-create-group.worker', import.meta.url), {
          type: 'module',
        });

        let data = {
          token: '',
          vault_user_folder_id: '',
          url: '',
          user_id: '',
          name: '',
        };

        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken?.toString();

        const token = `Bearer ${idToken}`;
        data.token = token;
        data.vault_user_folder_id = parentFolderData;
        data.url = `${environment.apiUrl}/api/vault/group`;
        data.user_id = userId;
        let date = new Date();
        data.name = 'Uploaded Files ' + date.toDateString();
        this.createGroupWorker.onmessage = ({ data }) => {
          //return security key generated by worker process

          // Terminate worker after receiving data
          if (this.createGroupWorker) {
            this.createGroupWorker.terminate();
            this.createGroupWorker = undefined;
          }

          resolve(data);
        };
        this.createGroupWorker.postMessage(data);
      } else {
        //browser does not support web-workers so just return a new data key, UI automation will be blocked
        resolve(this.generateDataKeyPair({}));
      }
    });
  }
  generateDataKeyPair(security_key: any): unknown {
    throw new Error('Method not implemented.');
  }

  async getDraggedItem(data, workspaceId, folderId, url, workSpaceFodlerName, vault_folder_id, userId, is_file) {
    const promise = [];
    for (let i = 0; i < data.items.length; i++) {
      let item = data.items[i].webkitGetAsEntry();
      let fileList = data.fileLists[i];
      item.size = fileList.size;
      item.type = fileList.type;
      (item.uniquesKey = data?.uniquesKey), (item.workSpaceFodlerName = workSpaceFodlerName);
      item.completed = false;
      if (item) {
        promise.push(this.scanAndLogFiles(item, workspaceId, folderId));
      }
    }

    await Promise.all(promise);
    setTimeout(async () => {
      let result;
      result = await this.createGroupData(folderId, userId);
      this.fileDataObjectTransferService.sendMessage('false');
      this.dataSource.data.forEach(async (element, index) => {
        this.fileDataObjectTransferService.updateApprovalMessage({
          data: this.dataSource.data[index],
          folderId,
          workspaceId,
          url,
          vault_folder_id,
          userId,
          is_file,
          groupId: result?.data?.id,
        });
      });
    }, 15000);
  }
  async scanAndLogFiles(item, workspaceId, folderId) {
    // const newFile = item.event.dataTransfer.files;
    let newElt = item;

    if (item.isDirectory) {
      const promise = [];
      let directoryReader = item.createReader();
      directoryReader.readEntries((entries) => {
        entries.forEach(async (entry) => {
          try {
            // this.readFile(entry, null, null)
          } catch (error) {}

          promise.push(this.scanAndLogFiles(entry, workspaceId, folderId));
        });
      });
      await Promise.all(promise);
    }

    if (item.isDirectory) {
      newElt.originalFile = undefined;
      this.data.folderList.push(newElt);
      this.getFoldersAndFiles(this.data?.folderList, workspaceId, folderId);
    } else {
      item.file((file) => {
        this.fileDataObjectTransferService.sendMessage('true');
        this.hasFile = true;
        newElt.originalFile = file;
        this.data.folderList.push(newElt);
        this.getFoldersAndFiles(this.data?.folderList, workspaceId, folderId);
      });
    }
  }
  getFoldersAndFiles(formList, workspaceId, folderId) {
    const tree = this.dragDropService.parsePathArray(formList);
    TREE_DATA = [...tree];
    this.dataSource.data = [...TREE_DATA];
  }
}
